import { useState, useEffect, useRef, useContext } from "react";
import OneArticle from '../ones/OneArticle';
import { AppContext } from "../App";
import { STR_ALL, STR_HEALTH_TIPS, STR_NO_DATA_FOUND, STR_SEARCH_HERE, STR_VIEW_MORE } from "../Strings";
import { callApi, getInlineLoader } from "../Helpers";
import { MdChevronRight, MdSearch } from "react-icons/md";

export default function Feed({ }) {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  
  const [filter, setFilter] = useState('');
  const [category, setCategory] = useState('');

  async function init() {
    setReady(false);
    await Promise.all(
      [
        appContext.getArticlesFeed(),
        appContext.getCurrentUserData(),
      ]
    )
    setReady(true);
  }

  
  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    
  }, [filter, category])

  if(ready) {
    return (
      <div
        style={{
          width: "100%",
        }}
      >
        <div className="container">
					<div className="row">
            
						<div className="col-md-12">
							<div className="mt-3 mb-2">
								<h6
									className="mSectionTitle text-primary mNoMargin"
								>
									{STR_HEALTH_TIPS[appContext.language]}
								</h6>

								
							</div>
						</div>

            <div 
              className="col-md-12"
              
            >
              <div 
                className="input-group bg-surface"
                style={{
                  borderRadius: "20px",
                  overflow: "hidden"
                }}
              >
                <span
                  className="input-group-text font-semi-bold bg-surface"
                  style={{
                    fontSize: "22px",
                    border: "none"
                  }}
                >
                  <MdSearch/>
                </span>
                <input
                  className="form-control mSearchField"
                  onChange={(e) => setFilter(e.target.value)}
                  value={filter}
                  placeholder={STR_SEARCH_HERE[appContext.language]}
                  type="text"
                  style={{
                    fontSize: "16px",
                  }}
                />
              </div>
      
              <div 
                className="d-flex overflow-auto mt-3 mNoScrollBar"
                style={{
                  paddingBottom: "20px"
                }}
              >
                <button 
                  className={(!category) ? "btn btn-rounded btn-primary me-2" : "btn btn-rounded btn-outline-secondary me-2"}
                  style={{
                    height: "40px",
                    width: "auto",
                    whiteSpace: "nowrap", // Prevents text wrapping
                    fontSize: "14px",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                  }}
                  onClick={() => {
                    setCategory('');
                  }}
                >
                  {STR_ALL[appContext.language]}
                </button>
      
                {JSON.parse(appContext.systemParams.articleCategories).map((item, i) => (
                  <button 
                    key={i} 
                    className={(category === item.id) ? "btn btn-rounded btn-primary me-2" : "btn btn-rounded btn-outline-secondary me-2"}
                    style={{
                      height: "40px",
                      width: "auto",
                      whiteSpace: "nowrap", // Prevents text wrapping
                      fontSize: "14px",
                    }}
                    onClick={() => {
                      setCategory(item.id);
                    }}
                  >
                    {item.description[appContext.language]}
                  </button>
                ))}

                
              </div>
              <hr/>
            </div>
            

            {
              (appContext.articlesFeed && appContext.articlesFeed.length > 0) ?
              appContext.articlesFeed.map((item, i) => {
      
                if(category) {
                  if(JSON.parse(item.categories).indexOf(category) > -1) {
                    if(filter && filter.trim().length > 0) {
                      if(String(item.title).toLowerCase().indexOf(String(filter).toLowerCase()) > -1) {
                        return (
                          <div className="col-md-4 col-md-12" key={i}>
                            <OneArticle data={item}/>
                            <hr/>
                          </div>
                        );
                      } else {
                        return null;
                      }
                    } else {
                      return (
                        <div className="col-md-4 col-md-12" key={i}>
                          <OneArticle data={item}/>
                          <hr/>
                        </div>
                      );
                    }
                  } else {
                    return null;
                  }
                } else {
                  if(filter && filter.trim().length > 0) {
                    if(String(item.title).toLowerCase().indexOf(String(filter).toLowerCase()) > -1) {
                      return (
                        <div className="col-md-4 col-md-12" key={i}>
                          <OneArticle data={item}/>
                          <hr/>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  } else {
                    return (
                      <div className="col-md-4 col-md-12" key={i}>
                        <OneArticle data={item}/>
                        <hr/>
                      </div>
                    );
                  }
                }
                
              })
              :
              <div className="col-md-12">
                <h6
                  style={{
                    fontSize: "12px"
                  }}
                >
                  {STR_NO_DATA_FOUND[appContext.language]}
                </h6>
              </div>
            }

					</div>
				</div>
      </div>
    );
  } else {
    return (
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
        className="mNoScrollBar"
      >
        <div className="container mSupportLoading">
          {getInlineLoader()}
        </div>
      </div>
    );
  }
}
